import React from "react";
import "./component.css";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

const AddTagsComponent = (props) => {
  return (
    <div className="form-row">
      {props.inputs.map((input, index) => (
        <Box key={index} className="form-field">
          <div className="input-group">
            <TextField
              fullWidth
              label="UID"
              name={`uid${index}`}
              value={input.uid || ""}
              onChange={(event) => props.handleInputChange(event, index, "uid")}
              readOnly={input.uidReadOnly}
              inputProps={{ maxLength: 10 }}
            />
            <TextField
              fullWidth
              label="Token"
              name={`token${index}`}
              value={input.token || ""}
              onChange={(event) => props.handleInputChange(event, index, "token")}
              readOnly={input.tokenReadOnly}
              inputProps={{ maxLength: 10 }}
            />
            <span className="add-more-link" onClick={props.addMoreInputs}>
              + Add more
            </span>
          </div>
        </Box>
      ))}
    </div>
  );
};

export default AddTagsComponent;